var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search_changed"},[_c('h4',[_vm._v(_vm._s(_vm.getTranslation('SEARCH_CHANGED')))]),_c('div',{staticClass:"search_changed_button_container"},[_c('div',{staticClass:"search_changed_button",on:{"click":_vm.searchResults}},[_vm._v(_vm._s(_vm.getTranslation('CHECKAVAILABILITY')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }